module.exports = __webpack_public_path__ + "fonts/GT-Medium.6a145c94.otf";